<template>
	<div class="flex items-center relative w-full bg-graycustom">
		<input
			:type="blok.type"
			:class="[
				blok.icon ? 'pl-10' : 'pl-4',
				`bg-[inherit] w-full h-9 text-gray-super-dark placeholder:text-gray-super-dark placeholder:text-xs text-xs lg:max-w-[331px]`
			]"
			:placeholder="blok.placeholder"
			:name="blok.name"
			:required="blok.required"
		/>
		<div
			v-if="blok.icon"
			class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
		>
			<MagnifyingGlassIcon class="h-4 w-4 text-primary" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { MagnifyingGlassIcon } from "@heroicons/vue/24/solid";
import type { BlokInput } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokInput;
}
const { blok } = defineProps<Props>();
</script>
